import React from 'react';
import { ButtonLegacy, RouterLink } from '~/shared/components';

interface CategoryLinkProps {
    url: string;
    name: string;
}

export const MobileCategoryLink = ({ url, name }: CategoryLinkProps) => {
    return (
        <RouterLink prefetch={false} href={url}>
            <ButtonLegacy
                as="a"
                href={url}
                title={name}
                variant="secondary"
                size="sm"
                rounded
                shape="icon"
            >
                {name}
            </ButtonLegacy>
        </RouterLink>
    );
};
